import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    isLoaded: false,
    csvUserID: null,
    userId: null,
    cipherText: null,
    SchoolId: null,
    supportTicketDetails: null,
    helpTicketDetails: null,
    UserTimeZone: 'America/New_York',
    AdminSchoolId: undefined,
    SchoolContactID: 0,
    Schoolname: '',
    Schoolnumber: '',
    SelectedSchoolTimeZone: '',
    DefaultTicketStatus: null,
    DefaultShippingMethod: 0,
    isEnterprise: false,
};
const authSlice = createSlice({
    name: 'authData',
    initialState,
    reducers: {
        setCsvUserID: (state, action) => {
            state.csvUserID = action.payload;
        },
        setUserId: (state, action) => {
            state.userId = action.payload;
        },
        setJwtToken: (state, action) => {
            state.cipherText = action.payload;
        },
        setSchoolId: (state, action) => {
            state.SchoolId = action.payload;
        },
        setIsEnterprise: (state, action) => {
            state.isEnterprise = action.payload;
        },
        setIsDev: (state, action) => {
            state.isDev = action.payload;
        },
        setSupportTicketDetails: (state, action) => {
            state.supportTicketDetails = action.payload;
        },
        setHelpTicketDetails: (state, action) => {
            state.supportTicketDetails = action.payload;
        },
        setUserTimeZone: (state, action) => {
            state.UserTimeZone = action.payload;
        },
        setAdminSchoolId: (state, action) => {
            state.AdminSchoolId = action.payload;
        },
        setSchoolContactID: (state, action) => {
            state.SchoolContactID = action.payload;
        },
        setSchoolname: (state, action) => {
            state.Schoolname = action.payload;
        },
        setSchoolnumber: (state, action) => {
            state.Schoolnumber = action.payload;
        },
        setSelectedSchoolTimeZone: (state, action) => {
            state.SelectedSchoolTimeZone = action.payload;
        },
        setDefaultTicketStatus: (state, action) => {
            state.DefaultTicketStatus = action.payload;
        },
        setDefaultShippingMethod: (state, action) => {
            state.DefaultShippingMethod = action.payload;
        },
        clearMenuData: (state) => {
            state.menuData = [];
            state.firstAccessibleRoute = null;
            state.schemeId = null;
            state.isLoaded = false;
        },
    },
});
export const { clearMenuData, setCsvUserID, setJwtToken, setSchoolId, setIsEnterprise, setIsDev, setSupportTicketDetails, setHelpTicketDetails, setUserTimeZone, setAdminSchoolId,
    setSchoolContactID, setSchoolname, setSchoolnumber, setSelectedSchoolTimeZone, setDefaultTicketStatus, setDefaultShippingMethod, setUserId
} = authSlice.actions;
export default authSlice.reducer;
